import * as React from "react";

import { cn } from "@/lib/utils";

import * as SliderPrimitive from "@radix-ui/react-slider";

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center",
      className
    )}
    data-testid="slider"
    {...props}
  >
    <SliderPrimitive.Track
      data-testid="slider-track"
      className={cn(
        "relative h-2 w-full grow overflow-hidden rounded-full bg-neutral-200 ",
        props.disabled && "bg-white-smoke"
      )}
    >
      <SliderPrimitive.Range
        className={cn(
          "absolute h-full bg-teal-500",
          props.disabled && "bg-light-gray"
        )}
      />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="block h-5 w-5 rounded-full border-2 border-gainsboro bg-white ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 " />
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
